require('./accordion');
require('./search');
require('./product-accordions');